<template>
  <div class="phone-link">
    <a
      v-b-tooltip.click
      :title="formattedNumber"
      class="d-none d-md-inline phone-icon"
    >
      <FontIcon name="ui_phone" />
      <slot />
    </a>
    <a :href="`tel:${number}`" class="d-md-none">
      <FontIcon name="ui_phone" />
      <slot />
    </a>
  </div>
</template>

<style lang="scss">
.phone-link {
  line-height: 22px;

  .phone-icon {
    font-size: 22px;
    height: 22px;
    display: block;
  }
}
</style>

<script>
import { parsePhoneNumberFromString } from "libphonenumber-js";

import FontIcon from "../FontIcon";

export default {
  components: { FontIcon },

  props: {
    id: {
      type: String,
      required: true,
    },
    number: {
      type: String,
      required: true,
    },
  },

  computed: {
    formattedNumber() {
      const phoneNumber = parsePhoneNumberFromString(this.number);
      return phoneNumber?.formatInternational() || this.number;
    },
  },
};
</script>
